module.exports = __webpack_public_path__ + "images/tabs/contacts-off.png";